import { minutesToMilliseconds } from 'date-fns';

export const PATIENT_DATA_STALE_TIME = minutesToMilliseconds(5);
